/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Sociology15Inputs */

const en__field__enum_studyprograms_study_sociology15 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Sociology15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sociology`)
};

const de__field__enum_studyprograms_study_sociology15 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Sociology15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soziologie`)
};

/**
* | output |
* | --- |
* | "Sociology" |
*
* @param {_Field__Enum_Studyprograms_Study_Sociology15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_sociology15 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Sociology15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Sociology15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_sociology15(inputs)
	return de__field__enum_studyprograms_study_sociology15(inputs)
});
export { _field__enum_studyprograms_study_sociology15 as "_field__enum_studyPrograms_STUDY_SOCIOLOGY" }